import { API_ADMIN_URL } from '../../../config/constants';
import { postRequest } from '../../API';

/*********************************************************
 * Function Name : list
 * Description   : Get paginated pull-out request list
 *********************************************************/
export const list = async (options) => {
    try {
        const params = {
            url: `${API_ADMIN_URL}accounts/request/pull-out-list`,
            postData: options,
        };
        const res = await postRequest(params);
        if (res.status === true || res.status === 200) {
            return { status: true, result: res?.data?.response?.result, count: res?.data?.response?.count };
        } else {
            return { status: false, message: res?.response?.data?.statusMessage };
        }
    } catch (error) {
        return { status: false, message: 'Under Maintenance, Please try after some time.' };
    }
};

/*********************************************************
 * Function Name : changeStatus
 * Description   : Approve or reject a pull-out request stage
 *********************************************************/
export const changeStatus = async (options) => {
    try {
        const params = {
            url: `${API_ADMIN_URL}accounts/request/pull-out-change-status`,
            postData: options,
        };
        const res = await postRequest(params);
        if (res.status === true || res.status === 200) {
            return { status: true, result: res?.data?.response?.result };
        } else {
            return { status: false, message: res?.response?.data?.statusMessage };
        }
    } catch (error) {
        return { status: false, message: 'Under Maintenance, Please try after some time.' };
    }
};

/*********************************************************
 * Function Name : revokePullOutRequest
 * Description   : Revoke (reject) a pull-out request
 *********************************************************/
export const revokePullOutRequest = async (options) => {
    try {
        const params = {
            url: `${API_ADMIN_URL}accounts/request/revoke-pull-out`,
            postData: options,
        };
        const res = await postRequest(params);
        if (res.status === true || res.status === 200) {
            return { status: true, result: res?.data?.response?.result };
        } else {
            return { status: false, message: res?.response?.data?.statusMessage };
        }
    } catch (error) {
        return { status: false, message: 'Under Maintenance, Please try after some time.' };
    }
};
